<template>
  <div id="shopban">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>商品管理&nbsp;/&nbsp;banner管理</span>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全 部" name="first">
        </el-tab-pane>
        <el-tab-pane label="首页banner" name="second">
        </el-tab-pane>
        <el-tab-pane label="分类banner" name="three">
        </el-tab-pane>
      </el-tabs>
        <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <Provinces @gain='gainSS' v-if="clearId"></Provinces>
           <!-- <el-input class="elinputs" v-model="beginData.name" placeholder="商品名称"></el-input> -->
            <el-select v-model="beginData.type" placeholder="选择类型" class="elinputs">
                <el-option v-for="item in beginData.types" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <el-select v-model="beginData.enabled" placeholder="是否显示" class="elinputs">
                <el-option v-for="item in beginData.isShows" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <el-button type="primary" class="query_btn" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0.4)" v-loading.fullscreen.lock="fullscreenLoading" @click="query">查询</el-button>
            <el-button type="info" class="reset_btn" @click='reset'>重置</el-button>
            </div>
            <div class="tit">
              <Reset @clkBtn='theBtn'></Reset>
              <Xlsx :name="formname"></Xlsx>
            </div>
            <el-table :data="tableData" id="exportTab" @selection-change="handleSelectionChange" border stripe style="width: 100%">
              <el-table-column type="selection" width="60"></el-table-column>
              <!-- <el-table-column prop="id" label="编号" width="60" :index="1"></el-table-column> -->
              <el-table-column type="index" label="序号" width="80" :index="1"></el-table-column>
              <el-table-column label="位置" min-width="160">
                  <template slot-scope="scope">
                      <p class="boldfont" v-if="scope.row.position==0" style="color:#E6A23C">首页</p><p class="boldfont" v-if="scope.row.position==1" style="color:#409EFF">分类banner</p>
                  </template>
              </el-table-column>
              <el-table-column prop="areasName" label="所属地区" min-width="180"></el-table-column>
              <el-table-column min-width="200" label="banner图">
                  <template slot-scope="scope">
                  <viewer>
                      <img class="sfzimg" :src="imgUrl+scope.row.imgUrl" />
                  </viewer>
                  </template>
              </el-table-column>
              <el-table-column label="类型" min-width="160">
                  <template slot-scope="scope">
                      <p class="boldfont" v-if="scope.row.type==1" style="color:#67C23A">指定商品</p><p class="boldfont" v-if="scope.row.type==2" style="color:#F56C6C">自定义地址</p>
                  </template>
              </el-table-column>
              <el-table-column prop="link" label="跳转地址" min-width="180"></el-table-column>
              <el-table-column prop="cname" label="分类名称" min-width="180"></el-table-column>
              <el-table-column min-width="200" label="分类图片">
                  <template slot-scope="scope">
                  <viewer>
                      <img class="sfzimg" :src="imgUrl+scope.row.cimgUrl" />
                  </viewer>
                  </template>
              </el-table-column>
              <el-table-column prop="goodsName" label="商品名称" min-width="180"></el-table-column>
              <el-table-column min-width="200" label="商品图片">
                  <template slot-scope="scope">
                  <viewer>
                      <img class="sfzimg" :src="imgUrl+scope.row.goodsImgUrl" />
                  </viewer>
                  </template>
              </el-table-column>
              <el-table-column label="是否显示" width="160">
                  <template slot-scope="scope">
                      <p class="boldfont" v-if="scope.row.enabled">是</p><p class="boldfont" v-if="!scope.row.enabled" style="color:#F56C6C">否</p>
                  </template>
              </el-table-column>
              <el-table-column prop="addTime" label="添加时间" min-width="180"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间" width="180"></el-table-column>
              <el-table-column label="操作" fixed="right" min-width="180">
                  <template slot-scope="scope">
                  <el-button size="mini" type="success" @click="handleEdit(2,scope.row,'shopban:update')"><i class="el-icon-edit"></i> 编辑</el-button>
                  <el-button size="mini" type="danger" @click="stop(scope.row,'shopban:delete')"><i class="el-icon-delete"></i> 删除</el-button>
                  </template>
              </el-table-column>
        </el-table>
      <div class="paging">
        <span>
          共
          <i class="pagingNum">{{total}}</i> 条
        </span>
        <Paging :gopage="total" @pag="pag"></Paging>
      </div>
    </el-card>
    <el-dialog title="banner添加/编辑" :visible.sync="dialogFormVisible" @close="dataClose" width="60%" class="block">
        <el-form>
            <el-form-item label="* 类型：">
                <el-radio v-model="details.type" label='2'>自定义地址</el-radio>
                <el-radio v-model="details.type" label='1'>指定商品</el-radio>
            </el-form-item>
            <el-form-item label="* 位置：">
                <el-radio v-model="details.position" label='0'>首页</el-radio>
                <el-radio v-model="details.position" label='1'>分类</el-radio>
            </el-form-item>
            <el-form-item label="* 所属地区：">
                <el-select v-model="sheng" placeholder="省份" @change="cksheng">
                    <el-option
                    v-for="item in shenglist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="shi" placeholder="城市" @change="ckshi" class="cty16">
                    <el-option
                    v-for="item in shilist"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="* 跳转地址：" v-if="details.type=='2'">
               <el-input placeholder="请输入跳转地址" v-model="details.link" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="* 分类选择：" v-if="details.position=='1'">
               <el-input placeholder="点击选择分类" v-model="details.previewName" auto-complete="off" :disabled="true"></el-input><el-button type="primary" style="margin-left: 2%;" @click="getshop(0)">选择</el-button>
            </el-form-item>
            <!-- <el-form-item label="* 分类banner图：" v-if="details.position=='1'">
                <viewer>
                    <img :src='details.preview' style="width:120px;margin: 14px 0;" />
                </viewer>
            </el-form-item> -->
            <el-form-item label="* 商品选择：" v-if="details.type=='1'">
               <el-input placeholder="点击选择商品" v-model="details.previewName1" auto-complete="off" :disabled="true"></el-input><el-button type="primary" style="margin-left: 2%;" @click="getshop(1)">选择</el-button>
            </el-form-item>
            <!-- <el-form-item label="* 商品banner图：" v-if="details.type=='1'">
                <viewer>
                    <img :src='details.preview1' style="width:120px;margin: 14px 0;" />
                </viewer>
            </el-form-item> -->
            <el-form-item label="* banner图片：" style='margin-bottom: 10px;'>
                <el-upload
                    class="upload-demo"
                    :action="URL"
                    :limit="1"
                    :on-remove="handleRemove"
                    :on-success="handleAvatarSuccess"
                    :data="newobj"
                    ref="upload"
                    :file-list="details.adUrls"
                    name="multipartFile"
                    :headers="newhead"
                    list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip"> 选择图标，推荐尺寸600*300px，大小100k以内</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="* 是否显示：">
                <el-radio v-model="details.enabled" label=true>是</el-radio>
                <el-radio v-model="details.enabled" label=false>否</el-radio>
            </el-form-item>
        </el-form>
        <el-dialog :title="details.getStat==0?'分类选择':'商品选择'" :visible.sync="innerVisible" @close="dataCloses" append-to-body id="datatext" width="60%">
          <el-form>
            <el-table :data="tableData2" border style="width: 100%">
                <el-table-column v-if="details.getStat==0" prop="id" label="分类编号" width="130"></el-table-column>
                <el-table-column v-if="details.getStat==0" key="21" prop="name" label="分类名称" min-width="130"></el-table-column>
                <el-table-column v-if="details.getStat==0" key="22" label="分类图标" width="200">
                    <template slot-scope="scope">
                        <viewer>
                            <img class="sfzimg" :src="imgUrl+scope.row.iconUrl" />
                        </viewer>
                    </template>
                </el-table-column>
                <el-table-column v-if="details.getStat==0" key="23" label="分类图片" width="200">
                    <template slot-scope="scope">
                        <viewer>
                            <img class="sfzimg" :src="imgUrl+scope.row.picUrl" />
                        </viewer>
                    </template>
                </el-table-column>
                <el-table-column v-if="details.getStat==0" key="24" prop="sortOrder" label="排序" width="100"></el-table-column>
                <el-table-column v-if="details.getStat==0" label="是否显示" sortable width="130">
                    <template slot-scope="scope">
                        <p class="boldfont" v-if="scope.row.isShow" style="color:#67C23A">是</p>
                        <p class="boldfont" v-else style="color:#F56C6C">否</p>
                    </template>
                </el-table-column>
                <el-table-column v-if="details.getStat==0" key="25" label="操作" fixed="right" width="120">
                    <template slot-scope="scope">
                        <el-button size="mini" type="success" @click="choice(0,scope.row)">
                          <i class="el-icon-edit"></i>选择
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column v-if="details.getStat==1" key="0" prop="id" label="商品编号" width="130"></el-table-column>
                <el-table-column v-if="details.getStat==1" key="1" :show-overflow-tooltip="true" prop="name" label="商品名称" min-width="130"></el-table-column>
                <el-table-column v-if="details.getStat==1" key="2" prop="deliveryAreaName" label="配送区域" min-width="130"></el-table-column>
                <el-table-column v-if="details.getStat==1" key="3" prop="supplierName" label="供应商" min-width="130"></el-table-column>
                <el-table-column v-if="details.getStat==1" key="4" label="是否预售" min-width="130">
                    <template slot-scope="scope">
                        <p class="boldfont" v-if="scope.row.isSale" style="color:#67C23A">是</p>
                        <p class="boldfont" v-else style="color:#F56C6C">否</p>
                    </template>
                </el-table-column>
                <el-table-column v-if="details.getStat==1" key="5" label="配送方式" min-width="130">
                  <template slot-scope="scope">
                      <p class="boldfont" v-if="scope.row.delivery==1">冷链配</p>
                      <p class="boldfont" v-if="scope.row.delivery==2">常温配</p>
                  </template>
                </el-table-column>
                <el-table-column v-if="details.getStat==1" key="6" label="banner图" width="200">
                    <template slot-scope="scope">
                        <viewer>
                            <img class="sfzimg" :src="imgUrl+scope.row.picUrl" />
                        </viewer>
                    </template>
                </el-table-column>
                <el-table-column v-if="details.getStat==1" key="7" label="组图" width="200">
                    <template slot-scope="scope">
                        <viewer>
                            <img class="sfzimg" v-for="(item,index) in scope.row.gallery.split(',')" :key="index" :src="imgUrl+item" />
                        </viewer>
                    </template>
                </el-table-column>
                <el-table-column v-if="details.getStat==1" key="8" prop="retailPrice" label="原价" min-width="130"></el-table-column>
                <el-table-column v-if="details.getStat==1" key="9" prop="discountPrice" label="优惠价" min-width="130"></el-table-column>
                <el-table-column v-if="details.getStat==1" key="10" prop="retailPrice" label="结算价" min-width="130"></el-table-column>
                <el-table-column v-if="details.getStat==1" key="11" prop="buyNum" label="销量（真）" min-width="130"></el-table-column>
                <el-table-column v-if="details.getStat==1" key="12" prop="buyNumFalse" label="销量（假）" min-width="130"></el-table-column>
                <el-table-column v-if="details.getStat==1" key="13" prop="stock" label="库存" min-width="130"></el-table-column>
                <el-table-column v-if="details.getStat==1" key="14" prop="sortOrder" label="排序" min-width="130"></el-table-column>
                <el-table-column v-if="details.getStat==1" key="15" label="状态" sortable width="130">
                    <template slot-scope="scope">
                        <p class="boldfont" v-if="scope.row.isOnSale" style="color:#67C23A">是</p>
                        <p class="boldfont" v-else style="color:#F56C6C">否</p>
                    </template>
                </el-table-column>
                <el-table-column v-if="details.getStat==1" key="16" prop="addTime" label="添加时间" min-width="130"></el-table-column>
                <el-table-column v-if="details.getStat==1" key="17" prop="updateTime" label="修改时间" width="130"></el-table-column>
                <el-table-column v-if="details.getStat==1" key="18" label="操作" fixed="right" width="120">
                    <template slot-scope="scope">
                        <el-button size="mini" type="success" @click="choice(1,scope.row)">
                          <i class="el-icon-edit"></i>选择
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
          </el-form>
          <div class="paging">
              <span>共<i class="pagingNum">{{textdata.total}}</i> 条</span>
              <Paging :gopage="textdata.total" @pag="pags"></Paging>
          </div>
        </el-dialog>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="puton">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import Xlsx from "@/components/Xlsx";
import EditorBar from '@/components/Richtext';
import Reset from "@/components/Reset";
import Paging from '@/components/Paging';
import Provinces from "@/components/Provinces";
export default {
  name: "shopban",
  components: {
    Xlsx,
    EditorBar,
    Reset,
    Paging,
    Provinces
  },
  data() {
    return {
      beginData:{isShows:[{id:1,name:'是'},{id:0,name:'否'}],types:[{id:1,name:'指定商品'},{id:2,name:'自定义地址'}],position:''},
      tableData: [],
      tableData2:[],
      tableData3:[],
      pageNum: 1,
      pageSize: 10,
      dialogFormVisible: false,
      innerVisible: false,
      details: {enabled:'true',type:'2',position:'0',adUrls:[]},
      userdata: {},
      total: 0,
      btn: [],
      fullscreenLoading: true,
      imgUrl: this.$Public.imgUrl,
      formname:JSON.stringify({name:'banner管理',hint:'shopban:export'}),
      // cid:'',
      // cidList:[],
      URL:`${this.$Public.URL}/api-r/upload/uploadImg`,
      newobj:{type:3},
      newhead:{
            accessToken:JSON.parse(sessionStorage.getItem('userdata')).token
      },
      inputVisible: false,

      sheng:'',
      shi:'',
      shenglist:[],
      shilist:[],
      status:'',
      activeName: 'first',
      textdata:{tableData2:[],pageNum:1,pageSize:10,total:0},
      multipleSelection:[],
      clearId:true
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    }
  },
  watch:{
    tableData2(newV){
      // console.log(123321)
      // default
    }
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem('region'))
    region.forEach(x => {
        if(x.level==0){
            this.shenglist.push(x)
            this.sheng=x.id
            this.beginData.sheng=x.id
        }
    });
    if(this.userdata.level==0){
        this.$axios.post(`/api-r/area/getSubordinateAreaList`,this.$qs.stringify({areasId:region[0].id}),{headers:{accessToken:this.userdata.token}})
        .then(res=>{
            if(res.data.success){
                this.$set(this,'shilist',res.data.areaListInfoList)
            }
        })
    }else{
        region.forEach(x=>{
            if(x.level==1){
                this.shilist.push(x)
            }
        })
        if(this.shilist.length==1){
            this.shi=this.shilist[0].id
            this.details.areasId = this.sheng +','+ this.shilist[0].id
            this.details.areasName = this.userdata.areasName
        }
    }

  },
  methods: {
    // 获取省市传入的id
    gainSS(i){
        this.beginData.areaId = i.id
    },
    dataCloses(){
        this.textdata.pageNum = 1
        this.textdata.pageSize = 10
    },
    //   多选编辑
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    //   多选删除
    choices(){
        if(this.multipleSelection.length == 0){
            return this.$message.error('请至少选择一项删除')
        }
        let arr = []
        this.multipleSelection.forEach(x=>{
            arr.push(x.id)
        })
        this.$confirm('此操作将删除选中内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let url = ``
            url = `/api-s/deleteBanner/${arr.join(',')}`
            this.$axios.post(url,{},{ headers: { accessToken: this.userdata.token }})
            .then(res=>{
                if(res.data.success==true){
                    this.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    this.begin();
                }else{
                    alert(res.data.msg)
                }
            })
        }).catch(() => {
            return
        });
    },
    //   判断当前点击的按钮
    theBtn(i){
        if(i==1){
            if(this.btn.indexOf('shopban:add')==-1){
                return this.$message.error('抱歉，用户暂无该权限')
            }
            this.handleEdit(1)
        }else if(i==2){
            if(this.btn.indexOf('shopban:update')==-1){
                return this.$message.error('抱歉，用户暂无该权限')
            }
            if(this.multipleSelection.length != 1){
                return this.$message.error('请勾选一项内容编辑')
            }
            this.handleEdit(2,this.multipleSelection[0])
        }else if(i==3){
            if(this.btn.indexOf('shopban:delete')==-1){
                return this.$message.error('抱歉，用户暂无该权限')
            }
            this.choices()
        }else if(i==4){
            this.query()
        }
    },
    // 点击选择获取内容
    choice(x,row){
      if(x==0){
        // 这是分类的选择
        this.details.cid = row.id
        this.details.cimgUrl = row.picUrl

        this.details.preview = this.imgUrl+row.picUrl
        this.details.previewName = row.name
      }else{
        // 这是商品的选择
        this.details.goodsImgUrl = row.picUrl
        this.details.goodsId = row.id

        this.details.preview1 = this.imgUrl+row.picUrl
        this.details.previewName1 = row.name
      }
      this.innerVisible = false
    },
    // 获取商品
    getshop(x){
      this.details.getStat = x
      let vidtext = this.$qs.stringify({
          pageNum: this.textdata.pageNum,
          pageSize: this.textdata.pageSize,
          adminAreasId: this.userdata.areasId
      })
      let url = ``
      if(x==0){
        url = `/api-s/getGoodsCategoryList`    //商品分类
      }else{
        url = `/api-s/getGoodsList`    //商品列表
      }
      this.$axios.post(url, vidtext, {headers: { accessToken: this.userdata.token }})
      .then(res => {
          if(res.data.success){
              this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
                  if(x==0){
                    this.tableData2 = res.data.pageInfo.list    //商品分类
                  }else{
                    this.tableData2 = res.data.pageInfo.list    //商品列表
                  }
                  this.textdata.total = res.data.pageInfo.total
              });
              this.fullscreenLoading = false;
              this.innerVisible = true
          }
      });
    },
    pags(val){
        this.textdata.pageNum = val.pageNum
        this.textdata.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.getshop(this.details.getStat)
    },
    handleClick(tab, event) {
        if(this.activeName == 'first'){
            this.beginData.position = ''
        }else if(this.activeName == 'second'){
            this.beginData.position = '0'
        }else{
            this.beginData.position = '1'
        }
        this.begin()
    },
    // 关闭清空内容
    dataClose(){
      if(this.shilist.length==1){
          this.details = {enabled:'true',type:'2',position:'0',adUrls:[],areasId:this.sheng +','+ this.shilist[0].id,areasName:this.userdata.areasName}
      }else{
          this.shi = ''
          this.details = {enabled:'true',type:'2',position:'0',adUrls:[]}
      }
      this.begin()
    },
    change(val) {
      console.log(val)
    },
    // 提交
    puton(){
      let url = ''
      this.details.CId = this.details.cid
      this.details.CImgUrl = this.details.cimgUrl
      if(this.status == 1){
          url = `/api-s/addBanner`
      }else if(this.status == 2){
          url = `/api-s/updateBanner`
      }
      if(!this.details.imgUrl){
        return this.$message.error('请完善必填信息')
      }
      this.fullscreenLoading = true;
      this.$axios.post(url, this.$qs.stringify(this.details), {headers: { accessToken: this.userdata.token }})
      .then(res=>{
          if(res.data.success){
              this.dialogFormVisible = false;
          }else{
              this.fullscreenLoading = false;
              this.$message.error(res.data.msg)
          }
          this.$refs.upload.clearFiles();
      })
    },
    // 地区id
    cksheng(val){
        this.$set(this,'shi','')
    },
    ckshi(val){
        this.details.areasId = this.sheng +','+ val
        let arr = []
        this.shenglist.forEach(x=>{
            if(this.sheng==x.id){
                arr.push(x.name)
            }
        })
        this.shilist.forEach(x=>{
            if(val==x.id){
                arr.push(x.name)
            }
        })
        this.details.areasName = arr.join(',')
    },
    // 略缩图处理
    handleRemove(file, fileList) {
        this.details.imgUrl = ''
    },
    handleAvatarSuccess(res, file) {
        this.details.imgUrl = res.url
    },
    reset() {
      this.beginData = {isShows:[{id:1,name:'是'},{id:0,name:'否'}],types:[{id:1,name:'指定商品'},{id:2,name:'自定义地址'}],position:this.beginData.position}// if(this.activeName == 'first'){
      this.clearId = false
      this.$nextTick(function() {
          this.clearId = true
      })
      this.begin();
    },
    // handleSizeChange(val) {
    //   this.pageSize = val;
    //   this.fullscreenLoading = true;
    //   this.begin();
    // },
    // handleCurrentChange(val) {
    //   this.pageNum = val;
    //   this.fullscreenLoading = true;
    //   this.begin();
    // },
    pag(val){
        this.pageNum = val.pageNum
        this.pageSize = val.pageSize
        this.fullscreenLoading = true;
        this.begin();
    },
    begin() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        name:this.beginData.name,
        areaId:this.beginData.areaId,
        enabled:this.beginData.enabled,
        adminAreasId: userdata.areasId,
        type:this.beginData.type,
        position:this.beginData.position
      });
      this.$axios
        .post(`/api-s/getBannerList`, data, {
          headers: { accessToken: userdata.token }
        })
        .then(res => {
          this.fullscreenLoading = false;
          if(res.data.success){
            // this.$set(this, "tableData", res.data.pageInfo.list);

            this.$nextTick(function(){  //不使用this.$nextTick()方法会报错
              this.$set(this, "tableData", res.data.pageInfo.list);
            });
            this.$set(this, "total", res.data.pageInfo.total);
            this.$message({
                type: 'success',
                message: res.data.msg
            });
          }else{
            this.$message(res.data.msg)
          }
        });
    },
    handleEdit(i,row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message.error('抱歉，用户暂无该权限')
        }
      this.status = i
      if(i == 2){
          row.enabled +=''
          row.type +=''
          row.position +=''
          row.preview = this.imgUrl+row.cimgUrl
          row.preview1 = this.imgUrl+row.goodsImgUrl
          row.previewName = row.cname
          row.previewName1 = row.goodsName
          row.adUrls = [{name:'banner图',url:`${this.imgUrl+row.imgUrl}`}]
          this.sheng = Number(row.areasId.split(',')[0])
          this.shi = Number(row.areasId.split(',')[1])
          this.$set(this, "details", row);
      }
      this.dialogFormVisible = true;
    //   this.$set(this, "information", i);
    },
    stop(row,hint) {
        if(hint&&this.btn.indexOf(hint)==-1){
            return this.$message.error('抱歉，用户暂无该权限')
        }
      this.$confirm('此操作将删除该条内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          this.$axios.post(`/api-s/deleteBanner/${row.id}`,{},{ headers: { accessToken: this.userdata.token }})
          .then(res=>{
              if(res.data.success==true){
                  this.$message({
                      type: 'success',
                      message: res.data.msg
                  });
                  // if(this.activeName == 'first'){
                    this.begin();
                  // }else{
                  //   this.classify();
                  // }
              }else{
                  alert(res.data.msg)
              }
          })
      }).catch(() => {
          return
      });
    },
    query() {
      this.fullscreenLoading = true;
        this.begin();
    }
  }
};
</script>
<style>
.el-table--border th, .el-table--border td{
  text-align: center
}
.w-e-toolbar{
  flex-wrap: wrap;
}
#shopban .el-input__inner {
  margin: 10px 0;
}
#shopban .el-menu.el-menu--horizontal{
  margin-bottom: 14px;
}
#shopban .el-menu-item.is-active{
  background: none
}
#shopban .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#shopban .el-tag{
  margin-right: 12px;
}
#shopban .block .el-select {
  /* margin: 0 8px; */
  width: 50%
}
#shopban .el-upload__tip {
    display: inline-block;
    margin-left: 14px;
}
.input-new-tag{
  width: 20%
}
#shopban .el-upload-list--picture .el-upload-list__item {
    /* width: 44%; */
    /* float: left; */
    /* margin-right: 2%; */
}
#shopban .el-form-item__content {
    width: 100%;
    line-height: 0px;
    display: flex;
    align-items: center;
}
#shopban .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#shopban .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#shopban .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#shopban .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#shopban .el-dialog__body {
  height: 382px;
}
#nei .el-dialog__body{
  height: 150px !important;
}
#shopban .el-form-item{
    display: flex;
    align-items: center;
    margin-bottom:0
}
#shopban .el-form-item__label{
    width: 160px
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx{
      color: red;
    margin-left: 8px;
}
</style>
